<div class="container-wrap">
	<h4 class="gen-title section-title">{{ "preferences" | langVal }}</h4>
	<!-- <hr class="separation-line" /> -->

	<div>
		<div class="row">
			<div class="gen-autocomplete-wrapper">
				<div class="input-group colstat-big-double">
					<input
						class="gen-autocomplete"
						[(ngModel)]="search"
						(keyup)="handleSearch()"
						[placeholder]="'search' | langVal"
						[title]="'search' | langVal"
					/>
					<span
						class="input-group-addon"
						icon="search"
					></span>
					@if (search?.length) {
						<app-icon
							icon="close"
							class="searchClear"
							pointer
							(click)="clear()"
						/>
					}
				</div>
			</div>
		</div>
		@for (cat of shown; track cat.name) {
			<!-- <div> -->
			<div>
				<div class="followup-title">{{ cat.name | langVal }}</div>
				<!-- </div> -->
				<div class="buttons-row">
					@for (field of cat.fields; track field.name) {
						@switch (field.name) {
							@case ("invoice_per_followup") {
								<div class="switch-btn switch-btn-subtle">
									<app-yes-no
										(onClick)="handleIPFChange()"
										[isCheck]="configcliniq.invoice_per_followup === 'yes'"
									/>
									<label (click)="handleIPFChange()">{{
										"invoice_per_followup" | langVal
									}}</label>
								</div>
							}
							@case ("enable_israel_invoice") {
								<div class="switch-btn switch-btn-subtle">
									<app-yes-no
										(onClick)="handleEIIChange()"
										[isCheck]="configcliniq.enable_israel_invoice === 'yes'"
									/>
									<label (click)="handleEIIChange()">
										{{ "enable_israel_invoice" | langVal }}
									</label>
								</div>
							}
							@case ("language") {
								<div>
									<label>{{ "language" | langVal }}</label>

									<app-gen-select
										[actualObj]="configcliniq"
										[errors]="errors"
										fieldName="lang"
										tabindex="64"
										(changeEvent)="validateAndSave()"
										optionsListName="langOpts"
										optionFieldId="value"
									/>
								</div>
							}
							@case ("default_font_size") {
								<div>
									<label>{{ "default_font_size" | langVal }}</label>

									<app-gen-select
										[actualObj]="configcliniq"
										[errors]="errors"
										fieldName="default_font_size"
										tabindex="65"
										(changeEvent)="validateAndSave()"
										[options]="fontSizeOpts"
										optionFieldName="value"
									/>
								</div>
							}
							@case ("default_font_for_documents") {
								<div>
									<label>{{ "default_font_for_documents" | langVal }}</label>

									<app-gen-select
										[actualObj]="configcliniq"
										[errors]="errors"
										tabindex="66"
										fieldName="default_font_for_documents"
										(changeEvent)="validateAndSave()"
										optionsListName="default_font_for_documents_opts"
										optionFieldId="value"
									/>
								</div>
							}
							@case ("default_font_size_for_documents") {
								<div>
									<label>{{
										"default_font_size_for_documents" | langVal
									}}</label>

									<app-gen-select
										[actualObj]="configcliniq"
										[errors]="errors"
										fieldName="default_font_size_for_documents"
										tabindex="65"
										(changeEvent)="validateAndSave()"
										[options]="fontSizeOpts"
										optionFieldName="value"
									/>
								</div>
							}
							@case ("MaxNumberOfPayments") {
								<div>
									<label>{{ "MaxNumberOfPayments" | langVal }}</label>
									<app-gen-select
										[actualObj]="configcliniq"
										[errors]="errors"
										tabindex="67"
										style="width: 100px"
										fieldName="MaxNumberOfPayments"
										(changeEvent)="validateAndSave()"
										[options]="MaxNumberOfPaymentsOpts"
										optionFieldName="value"
									/>
								</div>
							}
							@case ("time_to_logout") {
								<div>
									<label>{{ "time_to_logout" | langVal }}</label>
									<app-gen-input
										tabindex="63"
										[actualObj]="configcliniq"
										[errors]="errors"
										fieldName="time_to_logout"
										(keyupEvent)="validateAndSave()"
									>
									</app-gen-input>
								</div>
							}
							@case ("zones") {
								<app-cc-params-zones />
							}
							@case ("reports") {
								<app-cc-reports />
							}
							@default {
								<div
									[title]="`${(field.name | langVal)}: ${(field.text | langVal)}`"
									class="switch-btn switch-btn-subtle"
								>
									<app-yes-no
										(onClick)="changeYesNo(field.name)"
										[isCheck]="configcliniq[field.name] === 'yes'"
									/>
									<label (click)="changeYesNo(field.name)">
										{{ field.name | langVal }}
									</label>
									@if (field?.text) {
										<button
											class="btn btn-icon"
											titleLang="expand"
											(click)="field.show = !field.show"
											icon="help"
											class="mis-auto help"
										></button>
										@if (field?.show) {
											<div
												class="explanation"
												(click)="field.show = !field.show"
											>
												{{ field.text | langVal }}
											</div>
										}
									}
								</div>
								<!-- </div> -->
							}
						}
					}
				</div>
			</div>
		}
	</div>
</div>

@switch (modalProps?.name) {
	@case ("ita-get-auth") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="ita_get_auth"
			modalWrapperClass="modal-650"
		>
			<app-ita-get-auth (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("confirm-ipf-change") {
		<app-modal-wrap
			(onClose)="modalProps = null; handleIPFChangeApprove(false)"
			title="confirm_change_default_invoice_per_followup"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="modalProps = null; handleIPFChangeApprove($event)"
			/>
		</app-modal-wrap>
	}
}
